import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { getReferralPoints } from "api/OffersApi";
import { getCustomerId } from "utility/HeaderConfig";
import Reffer from "../images/reffer_img.jpg";
import SEO from "components/headers/Seo";

export default function ReferralPoints({ configImages }) {
  const [banner, setBanner] = useState("");
  const [referralPoints, setReferralPoints] = useState([]);
  const [totalPoints, setTotalPoints] = useState(null);
  const [totalValue, setTotalValue] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getBanner();
    initialFunction();
    // eslint-disable-next-line
  }, []);

  const getBanner = () => {
    configImages?.E_COMMERCE_BANNERS?.forEach((d) => { if (d.key === "referral") setBanner(d.value); });
  };

  const initialFunction = async () => {
    const customerId = getCustomerId();
    if (!customerId) { setLoading(false); return; }
    const res = await getReferralPoints(customerId);
    const data = res.response || [];
    setReferralPoints(data);
    setTotalPoints(data.reduce((a, c) => a + (c.referralPoints || 0), 0));
    setTotalValue(data.reduce((a, c) => a + (c.referralValue || 0), 0));
    setLoading(false);
  };

  return (
    <div style={{ background: "#fff" }}>
      <SEO title="Referral Points — AVM Jewellers" description="Your referral points." name="AVM Jewellers" type="article" />

      {/* Banner */}
      {banner ? (
        <img src={banner} alt="Referral Points" style={{ width: "100%", objectFit: "cover", maxHeight: 220, display: "block" }} />
      ) : (
        <div style={{ background: "var(--surface-cream)", borderBottom: "1px solid var(--gold-200)", padding: "48px 0", textAlign: "center" }}>
          <p className="ej-section-eyebrow">Rewards</p>
          <h1 style={{ fontFamily: "var(--font-display)", fontSize: "clamp(28px,4vw,44px)", fontWeight: 500, color: "var(--ink-900)", margin: 0 }}>Referral Points</h1>
        </div>
      )}

      {/* Breadcrumb */}
      <div className="container">
        <nav style={{ display: "flex", alignItems: "center", gap: 8, padding: "14px 0", fontSize: 13, color: "var(--ink-400)" }}>
          <Link to="/" style={{ color: "var(--ink-600)", textDecoration: "none" }}>Home</Link>
          <span>/</span>
          <span style={{ color: "var(--gold-500)", fontWeight: 500 }}>Referral Points</span>
        </nav>
      </div>

      <div className="container" style={{ paddingBottom: 80 }}>
        {!getCustomerId() ? (
          /* Not logged in */
          <div style={{ textAlign: "center", padding: "60px 0" }}>
            <div style={{ width: 80, height: 80, borderRadius: "50%", background: "var(--gold-100)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="var(--gold-500)" strokeWidth="1.5">
                <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            <h2 style={{ fontFamily: "var(--font-display)", fontSize: 26, fontWeight: 500, color: "var(--ink-900)", margin: "0 0 10px" }}>Sign In to View Points</h2>
            <p style={{ fontSize: 14, color: "var(--ink-400)", margin: "0 0 24px" }}>Please sign in to see your referral points and rewards.</p>
            <Link to="/LoginPage" style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "12px 28px", background: "var(--ink-900)", color: "#fff", borderRadius: "var(--radius-pill)", fontSize: 13, fontWeight: 600, textDecoration: "none" }}>
              Sign In
            </Link>
          </div>
        ) : loading ? (
          <div style={{ maxWidth: 600, margin: "40px auto" }}>
            <Skeleton height={120} style={{ borderRadius: "var(--radius-lg)", marginBottom: 16 }} />
            <Skeleton height={400} style={{ borderRadius: "var(--radius-lg)" }} />
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 32, maxWidth: 900, margin: "0 auto", paddingTop: 32 }}>

            {/* Left: stats */}
            <div>
              {/* Points card */}
              <div style={{ background: "linear-gradient(135deg,var(--gold-400),var(--gold-500))", borderRadius: "var(--radius-xl)", padding: "28px 32px", color: "#fff", marginBottom: 20, boxShadow: "var(--shadow-gold)" }}>
                <p style={{ margin: "0 0 4px", fontSize: 11, fontWeight: 700, letterSpacing: ".12em", textTransform: "uppercase", opacity: .75 }}>Total Points Earned</p>
                <div style={{ fontFamily: "var(--font-fam)", fontSize: 56, fontWeight: 500, lineHeight: 1, margin: "8px 0" }}>{totalPoints ?? 0}</div>
                <p style={{ margin: 0, fontSize: 11, opacity: .7 }}>Referral Points</p>
              </div>

              {/* Value card */}
              <div style={{ background: "#fff", border: "1px solid var(--gold-200)", borderRadius: "var(--radius-xl)", padding: "24px 28px", boxShadow: "var(--shadow-sm)" }}>
                <p style={{ margin: "0 0 4px", fontSize: 11, fontWeight: 700, letterSpacing: ".12em", textTransform: "uppercase", color: "var(--ink-400)" }}>Total Value</p>
                <div style={{ fontFamily: "var(--font-fam)", fontSize: 29, fontWeight: 500, color: "var(--gold-500)", lineHeight: 1, margin: "8px 0" }}>
                  ₹{(totalValue ?? 0).toLocaleString("en-IN")}
                </div>
                <p style={{ margin: 0, fontSize: 12, color: "var(--ink-400)" }}>Redeemable value from your points</p>
              </div>

              {/* Referral image */}
              <div style={{ borderRadius: "var(--radius-lg)", overflow: "hidden", marginTop: 20 }}>
                <img src={Reffer} alt="Referral Program" style={{ width: "100%", display: "block", objectFit: "cover" }} />
              </div>
            </div>

            {/* Right: history table */}
            <div>
              <h3 style={{ fontFamily: "var(--font-display)", fontSize: 22, fontWeight: 500, color: "var(--ink-900)", margin: "0 0 16px" }}>Points History</h3>
              {referralPoints.length === 0 ? (
                <div style={{ background: "var(--surface-cream)", borderRadius: "var(--radius-lg)", padding: 32, textAlign: "center", border: "1px solid var(--gold-200)" }}>
                  <p style={{ fontSize: 14, color: "var(--ink-400)", margin: 0 }}>No referral points yet. Refer friends to earn rewards!</p>
                </div>
              ) : (
                <div style={{ border: "1px solid var(--ink-100)", borderRadius: "var(--radius-lg)", overflow: "hidden" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ background: "var(--surface-cream)" }}>
                        {["Referred To", "Points", "Value"].map((h) => (
                          <th key={h} style={{ padding: "12px 16px", fontSize: 11, fontWeight: 700, letterSpacing: ".08em", textTransform: "uppercase", color: "var(--ink-400)", textAlign: "left", borderBottom: "1px solid var(--gold-200)" }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {referralPoints.map((row, i) => (
                        <tr key={i} style={{ borderBottom: "1px solid var(--ink-100)" }}>
                          <td style={{ padding: "12px 16px", fontSize: 13.5, color: "var(--ink-700)" }}>{row.referredToName || "—"}</td>
                          <td style={{ padding: "12px 16px", fontSize: 13.5, fontWeight: 600, color: "var(--gold-500)" }}>{row.referralPoints}</td>
                          <td style={{ padding: "12px 16px", fontSize: 13.5, color: "var(--ink-600)" }}>₹{row.referralValue}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}